import styled from 'styled-components'

const StatContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25rem;
    height: 20rem;
`

export default StatContainer